import { getMatomoCookieTableBody, getMatomoSiteDomain } from './matomo';
import { getGoogleAnalyticsCookieTableBody } from './googleAnalytics';

function getAnalyticsCookieTableBody() {
  const domain = getMatomoSiteDomain();
  return [...getMatomoCookieTableBody(domain), ...getGoogleAnalyticsCookieTableBody(domain)];
}

const analyticsCookies = getAnalyticsCookieTableBody();

export const matomoAnalyticsSections = {
  en: {
    title: 'Analytics Cookies (Matomo & Google Analytics)',
    description:
      'These cookies help us understand how visitors use the site (pages viewed, traffic). Data may be processed by Matomo and/or Google Analytics depending on configuration; you can refuse them without affecting core features.',
    linkedCategory: 'analytics',
    cookieTable: {
      headers: {
        name: 'Name',
        domain: 'Domain',
        description: 'Description',
        expiration: 'Expiration',
      },
      body: analyticsCookies,
    },
  },
  es: {
    title: 'Cookies de Análisis (Matomo y Google Analytics)',
    description:
      'Estas cookies nos ayudan a entender cómo se utiliza el sitio (páginas vistas, tráfico). Los datos pueden procesarse en Matomo y/o Google Analytics según la configuración; puede rechazarlas sin afectar las funciones principales.',
    linkedCategory: 'analytics',
    cookieTable: {
      headers: {
        name: 'Nombre',
        domain: 'Dominio',
        description: 'Descripción',
        expiration: 'Expiración',
      },
      body: analyticsCookies,
    },
  },
  fr: {
    title: "Cookies d'Analyse (Matomo et Google Analytics)",
    description:
      "Ces cookies nous aident à comprendre l'utilisation du site (pages vues, trafic). Les données peuvent être traitées par Matomo et/ou Google Analytics selon la configuration ; vous pouvez les refuser sans impact sur les fonctionnalités essentielles.",
    linkedCategory: 'analytics',
    cookieTable: {
      headers: {
        name: 'Nom',
        domain: 'Domaine',
        description: 'Description',
        expiration: 'Expiration',
      },
      body: analyticsCookies,
    },
  },
};
